import { MouseEvent, useRef } from "react";
import TabsItem from "./TabsItem";
import styles from "./Tabs.module.css";

interface TabsProps {
    options: string[];
    onItemClick: (id: number) => void;
    tabMenuIdx: number;
}
/**
 * @author bakim
 * @date 2024-09-11 10:56:38
 * @remark 상단 탑 메뉴
 * @param {string[]} options: (required) 메뉴 명 목록
 * @param onItemClick: (required) 메뉴 선택(클릭) 시 콜백 함수
 * @param {number} tabMenuIdx: (required) 선택한 탭의 인덱스
 * @returns Tabs
 */
const Tabs = (props: TabsProps) => {
    const tabsRef = useRef<HTMLDivElement>(null);

    return (
        <div className={styles.container} ref={tabsRef}>
            {props.options.map((item: string, index: number) => {
                const active = index === props.tabMenuIdx;
                const onClickItem = (e: MouseEvent<HTMLElement>) => {
                    props.onItemClick(index);
                };
                return <TabsItem key={`submenu_${index}`} active={active} canHover={index === 2 ? false : true} title={item} onItemClick={onClickItem} />;
            })}
        </div>
    );
};

export default Tabs;
